/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instruction_6Inputs */



/**
* | output |
* | --- |
* | "Paste the Activation Code in the form field above" |
*
* @param {Login_Offline_Instruction_6Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instruction_6 = /** @type {((inputs?: Login_Offline_Instruction_6Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instruction_6Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Collez le Code d'Activation dans le champ du formulaire ci-dessus")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie den Aktivierungscode in das obige Formularfeld ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incolla il codice di attivazione nel campo del modulo sopra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте код активации в поле формы выше.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pegue el código de activación en el campo de formulario de arriba")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请将激活码粘贴到上方表单字段中。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("上記のフォームフィールドにアクティベーションコードを貼り付けてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऊपर दिए गए फॉर्म फ़ील्ड में एक्टिवेशन कोड पेस्ट करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cole o código de ativação no campo do formulário acima.")
	return /** @type {LocalizedString} */ ("Paste the Activation Code in the form field above")
});